// extracted by mini-css-extract-plugin
export default {"content":"style_content__R+ao2","leftSide":"style_leftSide__a+HhW","rightSide":"style_rightSide__NyFlS","type":"style_type__sG4qf","subheader":"style_subheader__wzesX"};